import {
  AddCartItemRQ,
  UpdateCartRQ,
} from '../../dto/request/shopping-cart.request';

export class GetShoppingCart {
  static readonly type = '[Shopping Cart] Get';
}

export class ClearCart {
  static readonly type = '[Shopping Cart] Clear';

  constructor() {}
}

export class AddCartItem {
  static readonly type = '[ShoppingCart] AddToCartItem';

  constructor(public cartItem: AddCartItemRQ) {}
}

export class UpdateCart {
  static readonly type = '[Shopping Cart] UpdateCartItem';

  constructor(public payload: UpdateCartRQ) {}
}
